<template>
  <div class="alarm-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-date-picker
            v-model="data.time"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          ></el-date-picker>
          <el-input
            v-model="data.name"
            placeholder="请输入租赁人"
            style="width: 210px; display: inline-block; margin-left: 10px"
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div>
        <!-- <div class="right">
          <el-button type="primary" v-if="$store.state.home.RoleId==this.user_role_rent" style="margin-left: 16px;" icon="el-icon-plus" @click="addRentInfo">发起租赁信息</el-button>
        </div>-->
      </div>
      <el-table
        stripe
        v-loading="loading"
        :data="table.data"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="tables"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
        ></el-table-column>
        <!-- <el-table-column
          prop="car_num"
          label="车架号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="tbox_num"
          label="TBox编号"
          align="center">
        </el-table-column>-->
        <el-table-column
          prop="license_num"
          label="车牌号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="start_time"
          label="租赁开始日期"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="end_time"
          label="租赁结束日期"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="current_mile"
          label="租车时里程"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="over_mile"
          label="已行驶里程"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="compute_mile"
          label="当前里程"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="租赁人"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div class="edit">
              <div v-if="scope.row.car_status == 1 && scope.row.end_time == ''">
                <span
                  class="btn read"
                  @click="
                    getBack(
                      scope.row.id,
                      scope.row.car_status,
                      scope.row.car_num
                    )
                  "
                  v-hasPermi="['租赁信息管理', '收回']"
                  >收回</span
                >
              </div>
              <div v-else>
                <span
                  class="btn read"
                  @click="
                    readClick(
                      scope.row.id,
                      scope.row.car_status,
                      scope.row.car_num
                    )
                  "
                  v-hasPermi="['租赁信息管理', '详情']"
                  >查看</span
                >
              </div>
              <!-- <span class="btn read" @click="deleteClick(scope.row.id,scope.row.car_status,scope.row.car_num)">删除</span> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.currentPage"
          :page-size="table.size"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </div>
      <!-- <div class="echertBox">
        <div class="box1">
          <div class="box1-1" ref="chart1"></div>
        </div>
        <div class="box1">
          <div class="box1-1" ref="chart2"></div>
        </div>
      </div> -->
      <div>
        <!-- 点击发起，弹出对话框 -->
        <el-dialog
          :title="title"
          :visible.sync="dialogVisible"
          width="70%"
          @close="close"
        >
          <div>车辆信息</div>
          <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-row :gutter="20">
              <el-col :span="11">
                <el-form-item label="车牌号">
                  <el-input
                    v-model="form.licenseNum"
                    v-if="status == 2"
                    :disabled="!editflge"
                    @focus.stop="Visible = true"
                    placeholder="请输入"
                  ></el-input>
                  <el-input
                    v-model="form.licenseNum"
                    v-else
                    :disabled="!editflge"
                    @focus.stop="Visible = true"
                    placeholder="请输入"
                  ></el-input>
                  <!-- <el-input disabled="disabled" v-model="form.licenseNum" placeholder="请输入"></el-input> -->
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="底盘型号">
                  <el-input
                    disabled="disabled"
                    v-model="form.chassis"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="11">
                <el-form-item label="车辆品牌">
                  <el-input
                    disabled="disabled"
                    v-model="form.brand"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="车辆型号">
                  <el-input
                    disabled="disabled"
                    v-model="form.type"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row :gutter="20">
              <el-col :span="11">
                <el-form-item label="Tbox编号">
                  <el-input disabled="disabled" v-model="form.tboxNum" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="车架号" prop="vin">
                    <el-input v-model="form.vin" v-if ="status == 2 "  :disabled="!editflge" @focus.stop="Visible=true" placeholder="请输入"></el-input>
                    <el-input v-model="form.vin" v-else :disabled="!editflge" @focus.stop="Visible=true" placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>
            </el-row>-->

            <div>租凭人信息</div>
            <el-row :gutter="20">
              <el-col :span="11">
                <el-form-item label="身份证" prop="idCard">
                  <el-input
                    v-if="status == 2"
                    :disabled="editflge"
                    v-model="form.idCard"
                    placeholder="请输入"
                  ></el-input>
                  <el-input
                    v-else
                    :disabled="!editflge"
                    v-model="form.idCard"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="驾照类型" prop="driver">
                  <el-select
                    v-if="status == 2"
                    :disabled="editflge"
                    style="width: 100%"
                    v-model="form.driver"
                    clearable
                    placeholder="请选择驾照类型"
                  >
                    <el-option
                      v-for="item in options.driverType"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-else
                    :disabled="!editflge"
                    style="width: 100%"
                    v-model="form.driver"
                    clearable
                    placeholder="请选择驾照类型"
                  >
                    <el-option
                      v-for="item in options.driverType"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="11">
                <el-form-item label="名称" prop="name">
                  <el-input
                    v-if="status == 2"
                    :disabled="editflge"
                    v-model="form.name"
                    placeholder="请输入"
                  ></el-input>
                  <el-input
                    v-else
                    :disabled="!editflge"
                    v-model="form.name"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item label="驾照号码" prop="driverNum">
                  <el-input
                    v-if="status == 2"
                    :disabled="editflge"
                    v-model="form.driverNum"
                    placeholder="请输入"
                  ></el-input>
                  <el-input
                    v-else
                    :disabled="!editflge"
                    v-model="form.driverNum"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="11">
                <el-form-item label="联系电话" prop="iphone">
                  <el-input
                    v-if="status == 2"
                    :disabled="editflge"
                    v-model="form.iphone"
                    placeholder="请输入"
                  ></el-input>
                  <el-input
                    v-else
                    :disabled="!editflge"
                    v-model="form.iphone"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="status == 1">
              <el-row :gutter="20">
                <el-col :span="11">
                  <el-form-item label="发起日期" prop="startTime">
                    <el-date-picker
                      :disabled="!editflge"
                      style="width: 100%"
                      :picker-options="pickerOptions"
                      v-model="form.startTime"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="当前里程数" prop="currentMile">
                    <el-input
                      :disabled="!editflge"
                      v-model="form.currentMile"
                      placeholder="请输入"
                      ><template slot="append">km</template></el-input
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div v-else-if="status == 2">
              <el-row :gutter="20">
                <el-col :span="11">
                  <el-form-item label="结束日期" prop="endTime">
                    <el-date-picker
                      :disabled="!editflge"
                      :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 100%"
                      v-model="form.endTime"
                      type="datetime"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="结束里程数" prop="overMile">
                    <el-input
                      :disabled="!editflge"
                      v-model="form.overMile"
                      placeholder="请输入"
                      ><template slot="append">km</template></el-input
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div v-else>
              <el-row :gutter="20">
                <el-col :span="11">
                  <el-form-item label="发起日期" prop="startTime">
                    <el-date-picker
                      :disabled="!editflge"
                      style="width: 100%"
                      :picker-options="pickerOptions"
                      v-model="form.startTime"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="当前里程数" prop="currentMile">
                    <el-input
                      :disabled="!editflge"
                      v-model="form.currentMile"
                      placeholder="请输入"
                      ><template slot="append">km</template></el-input
                    >
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="11">
                  <el-form-item label="结束日期" prop="endTime">
                    <el-date-picker
                      :disabled="!editflge"
                      style="width: 100%"
                      :picker-options="pickerOptions"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="form.endTime"
                      type="datetime"
                      placeholder="选择日期"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item label="结束里程数" prop="overMile">
                    <el-input
                      :disabled="!editflge"
                      v-model="form.overMile"
                      placeholder="请输入"
                      ><template slot="append">km</template></el-input
                    >
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-row :gutter="20">
              <el-col :span="11">
                <el-form-item label="车辆所属用户" v-show="false">
                  I
                  <el-input
                    v-model="form.userId"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-button
              v-if="status == 1"
              type="primary"
              @click="submitRentInfo('form')"
              >确认发起</el-button
            >
            <el-button
              v-else-if="status == 2"
              type="primary"
              @click="confirmGetBack('form')"
              >确认收回</el-button
            >
            <el-button v-else type="primary" @click="returnBack()"
              >返回</el-button
            >
          </el-form>
        </el-dialog>
        <popup v-if="Visible" @parent="childHanel" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetLeaseList,
  addRentInfo,
  getLeaseDetail,
  updateRentInfo,
  deleteRentInfo
} from "@/api/lease";
import { queryCarMileage } from "@/api/car";
import { MessageBox } from "element-ui";
import popup from "./popup";
export default {
  components: { popup },
  data () {
    return {
      dialogVisible: false,
      editflge: false,
      Visible: false,
      status: "1", //1 新增  2 编辑 3 查看
      options: {
        driverType: [
          { id: "A1", name: "A1" },
          { id: "A2", name: "A2" },
          { id: "A3", name: "A3" }
        ]
      },
      data: {
        time: "",
        name: ""
      },
      loading: false,
      form: {},
      table: {
        data: [],
        height: 100,
        currentPage: 1,
        size: 50,
        total: 0
      },
      title: "",
      rules: {
        vin: [{ required: true, message: "请选择车架号", trigger: "blur" }],
        idCard: [{ required: true, message: "请填写身份证", trigger: "blur" }],
        driver: [{ required: true, message: "请填驾照类型", trigger: "blur" }],
        driverNum: [
          { required: true, message: "请填驾照号码", trigger: "blur" }
        ],
        iphone: [{ required: true, message: "请填联系电话", trigger: "blur" }],
        name: [{ required: true, message: "请填名称", trigger: "blur" }],
        startTime: [
          { required: true, message: "请选择发起时间", trigger: "blur" }
        ],
        currentMile: [
          { required: true, message: "请填写当前里程数", trigger: "blur" },
          { pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,4})?$/, message: '输入数字最多四位小数' }
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "blur" }
        ],
        overMile: [
          { required: true, message: "请填写结束里程数", trigger: "blur" },
          { pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,4})?$/, message: '输入数字最多四位小数' }
        ]
      },
      pickerOptions: {
        disabledDate: time => {
          let nowData = new Date();
          nowData = new Date(nowData.setDate(nowData.getDate() - 1));
          return time < nowData;
        }
      },
      chart1: {
        element: "",
        option: {
          title: {
            text: "出租率"
          },
          tooltip: {
            trigger: "item",
            formatter: "{a} <br/>{b}: {c} ({d}%)"
          },
          legend: {
            orient: "horizontal",
            // x: "right", //可设定图例在左、右、居中
            // y: "center",
            left: "center",
            bottom: 0,
            data: ["分类一", "分类二", "分类三", "分类四", "Other"]
          },
          color: ["red", "orange", "yellow", "green", "grey", "indigo", "grey"],
          series: [
            {
              name: "访问来源",
              type: "pie",
              radius: ["50%", "70%"],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: "center"
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: "30",
                  fontWeight: "bold"
                }
              },
              labelLine: {
                show: false
              },
              data: [
                { value: 335, name: "分类一" },
                { value: 310, name: "分类二" },
                { value: 234, name: "分类三" },
                { value: 135, name: "分类四" },
                { value: 1548, name: "Other" }
              ]
            }
          ]
        }
      },
      chart2: {
        element: "",
        option: {
          title: {
            text: "出租时常"
          },
          color: ["#d9e3fb", "#dcf4ea"],
          // tooltip: {
          //   trigger: "axis",
          //   axisPointer: {
          //     type: "cross",
          //     label: {
          //       backgroundColor: "#6a7985"
          //     }
          //   }
          // },
          // legend: {
          //   data: ["邮件营销", "联盟广告"]
          // },
          // toolbox: {
          //   feature: {
          //     saveAsImage: {}
          //   }
          // },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: [
            {
              axisLine: {
                //---坐标轴 轴线
                show: false
              },
              type: "category",
              boundaryGap: false,
              data: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
            }
          ],
          yAxis: [
            {
              type: "value",
              axisLine: {
                //---坐标轴 轴线
                show: false
              }
            }
          ],
          series: [
            {
              name: "邮件营销",
              type: "line",
              stack: "总量",
              areaStyle: {},
              smooth: true,
              areaStyle: {
                normal: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#d9e3fb" // 0% 处的颜色
                      }
                      // {
                      //   offset: 0.7,
                      //   color: "rgba(220,56,129,0)" // 100% 处的颜色
                      // }
                    ],
                    globalCoord: false // 缺省为 false
                  }
                }
              },
              data: [120, 132, 101, -134, 90, 230, 810]
            },
            {
              name: "联盟广告",
              type: "line",
              stack: "总量",
              areaStyle: {},
              smooth: true,
              areaStyle: {
                normal: {
                  color: {
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#dcf4ea" // 0% 处的颜色
                      }
                      // {
                      //   offset: 0.7,
                      //   color: "rgba(220,56,129,0)" // 100% 处的颜色
                      // }
                    ],
                    globalCoord: false // 缺省为 false
                  }
                }
              },
              data: [220, 182, 191, 234, 290, 330, 210]
            }
          ]
        }
      }
    };
  },
  created () {
    this.getData();
  },

  mounted () {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170;
      window.onresize = () => {
        this.table.height =
          window.innerHeight - this.$refs.table.offsetTop - 170;
      };
    });
    // this.chartsInit();
  },
  methods: {
    close () { },
    returnBack () {
      this.dialogVisible = false;
    },
    addRentInfo () {
      this.dialogVisible = true;
      this.title = "发起租赁";
      this.editflge = true;
      this.status = "1";
      this.form = {};
    },
    getData () {
      this.loading = true;
      const params = {
        start: this.table.currentPage,
        size: this.table.size,
        name: this.data.name,
        time: this.data.time
      };
      this.data.time ? (params.time = this.data.time) : "";
      this.data.name ? (params.name = this.data.name) : "";
      GetLeaseList(params).then(res => {
        this.loading = false;
        const data = res.data;
        const total = res.data.total;
        let tboxs = data.tBoxs;
        let arr = []; //"Y20190701FC0001AA"
        if (tboxs != "") {
          arr = tboxs.split(",");
        }
        //arr.push("YYT201907010001V1111222333AAA");
        const param = { sn: JSON.stringify(arr) };
        queryCarMileage(param).then(res => {
          const tbData = res.data;
          if (res.code == 0 && data.content.length > 0) {
            for (var j = 0; j < total; j++) {
              if (
                data.content[j].tbox_num != "" &&
                (data.content[j].end_time == "" ||
                  data.content[j].end_time == null)
              ) {
                for (var i = 0; i < tbData.length; i++) {
                  if (data.content[j].tbox_num == tbData[i].sn) {
                    data.content[j].over_mile = tbData[i].totalMileage;
                  }
                }
              }
            }
          }
          this.$refs.tables.bodyWrapper.scrollTop = 0;
        });
        this.table.data = data.content;
        this.table.total = data.total;
      });
    },
    search () {
      this.currentPage = 1;
      this.getData();
    },
    //收回
    getBack (id, car_status, frame_num) {
      this.status = "2";
      this.editflge = true;
      this.dialogVisible = true;
      const params = { id: id, car_status: car_status, frame_num: frame_num };
      this.getLeaseDetails(params);
    },
    confirmGetBack (formName) {
      const data = {
        vin: this.form.vin,
        endTime: this.form.endTime,
        overMile: this.form.overMile
      };
      this.$refs[formName].validate(valid => {
        if (valid) {
          updateRentInfo(data).then(res => {
            if (res.code == 0) {
              this.$message.success(res.message);
              this.search();
              this.dialogVisible = false;
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    getLeaseDetails (params) {
      getLeaseDetail(params).then(res => {
        this.form = res.data.content;
        console.log(this.form);
      });
    },
    //查看
    readClick (id, car_status, frame_num) {
      this.dialogVisible = true;
      this.title = "租赁详情";
      this.editflge = false;
      this.status = "3";
      const params = { id: id, car_status: car_status, frame_num: frame_num };
      console.log(params);
      this.getLeaseDetails(params);
    },
    //删除租赁信息
    deleteClick (id) {
      MessageBox.confirm("是否删除该租赁信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          const params = { id: id };
          deleteRentInfo(params).then(res => {
            if (res.code == 0) {
              this.$message.success(res.message);
              this.search();
            } else {
              this.$message.error(res.message);
            }
          });
        })
        .catch(() => {
          this.$message("已取消删除");
        });
    },
    //提交房车租赁表单信息
    submitRentInfo (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          addRentInfo(this.form).then(res => {
            if (res.code == 0) {
              this.$message.success(res.message);
              this.search();
              this.dialogVisible = false;
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    //反选车辆信息
    childHanel (val) {
      this.form.vin = val.frame_num;
      this.form.type = val.type;
      this.form.brand = val.brand;
      this.form.chassis = val.chassis;
      this.form.licenseNum = val.license_num;
      this.form.userId = val.belong_userid;
      this.form.tboxNum = val.tbox_num;
      this.$refs.form.clearValidate("vin");
    },
    currentChange () {
      this.getData();
    },
    handleSizeChange (e) {
      this.table.currentPage = 1
      this.table.size = e
      this.getData()
    },
    chartsInit () {
      this.chart1.element = this.$echarts.init(this.$refs.chart1);
      this.chart2.element = this.$echarts.init(this.$refs.chart2);

      this.chart1.element.setOption(this.chart1.option, true);

      this.chart2.element.setOption(this.chart2.option, true);
    }
    // setOptions() {
    //   const data = []
    //   for (let seriesIndex = 0; seriesIndex < 5; seriesIndex++) {
    //     const seriesData = [];
    //     for (let i = 0; i < 12; i++) {
    //       const cate = []
    //       for (let j = 0; j < 100; j++) {
    //         cate.push(Math.random() * 20)
    //       }
    //       seriesData.push(cate)
    //     }
    //     data.push(this.$echarts.dataTool.prepareBoxplotData(seriesData))
    //   }

    // }
  }
};
</script>

<style lang="less" scoped>
.alarm-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    overflow: auto;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .type {
      .iconfont {
        display: inline-block;
        width: 40px;
        text-align: center;
        color: #f00;
      }
    }
    .status {
      &.red {
        color: #f00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.alarm-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}

//房车租赁表单样式
.el-form {
  padding-right: 20px;
}
.container {
  .bnt-bottom {
    /deep/ .el-form-item__content {
      width: 100%;
      text-align: center;
      margin-top: 10px;
      margin-left: 0 !important;
    }
  }
}

.echertBox {
  height: 49%;
  display: flex;
  justify-content: space-around;
  .box1 {
    width: 48%;
    height: 100%;
    position: relative;
    .box1-1 {
      width: 100%;
      height: 100%;
    }
    span {
      position: absolute;
      top: 10;
      left: 10;
    }
  }
  .box2 {
    width: 49%;
    height: 100%;
    background-color: pink;
  }
}
//车辆弹出框样式
</style>
